import React from 'react';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';

class EditSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = { value: props.value || '' };
  }

  componentDidUpdate(prevProps) {
    const { value } = this.props;
    if (value !== prevProps.value) this.setState({value});
  }

  delayedOnSearch = debounce(value => {
    this.props.onChange(value)
  }, 500)

  handleChange = (event) => {
    const value = event.target.value;
    this.setState({value});
    this.delayedOnSearch(value);
  }

  handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.keyCode === 13) {
      event.preventDefault();
      event.stopPropagation();
      this.delayedOnSearch.cancel();
      this.props.onChange(this.state.value);
    }
  }

  render() {
    return <input
      className='u-margin-bottom--zero'
      placeholder={this.props.placeholder}
      type="text"
      value={this.state.value}
      onChange={this.handleChange}
      onKeyDown={this.handleKeyDown}
      disabled={this.props.disabled}
    />
  }
}

EditSearch.propTypes = {
  placeholder: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
}

export default EditSearch;
